import React, { useEffect, useState, useCallback } from 'react';
import './Fireworks.css';

const Fireworks = () => {
  const [fireworks, setFireworks] = useState([]);
  
  // Get a random color for the firework
  const getRandomColor = () => {
    const colors = [
      '#ff0000', // Red
      '#ffff00', // Yellow
      '#00ff00', // Green
      '#00ffff', // Cyan
      '#ff00ff', // Magenta
      '#ff69b4', // Hot Pink
      '#ffa500', // Orange
      '#9932cc'  // Purple
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };
  
  // Wrap createFireworks in useCallback to prevent it from changing on every render
  const createFireworks = useCallback(() => {
    // Create 3 fireworks at random positions
    const newFireworks = [];
    for (let i = 0; i < 3; i++) {
      newFireworks.push({
        id: Date.now() + i,
        left: Math.random() * 100,
        top: 40 + Math.random() * 40,
        size: 0.5 + Math.random() * 0.5,
        color: getRandomColor()
      });
    }
    
    setFireworks(prev => [...prev, ...newFireworks]);
    
    // Remove fireworks after animation completes
    setTimeout(() => {
      setFireworks(prev => prev.filter(fw => !newFireworks.find(nfw => nfw.id === fw.id)));
    }, 1500);
  }, []);
  
  useEffect(() => {
    // Create initial fireworks
    createFireworks();
    
    // Add more fireworks every 800ms
    const interval = setInterval(() => {
      createFireworks();
    }, 800);
    
    // Clean up
    return () => clearInterval(interval);
  }, [createFireworks]);
  
  // getRandomColor function has been moved above createFireworks
  
  return (
    <div className="fireworks-container">
      {fireworks.map(fw => (
        <div 
          key={fw.id}
          className="firework"
          style={{
            left: `${fw.left}%`,
            top: `${fw.top}%`,
            transform: `scale(${fw.size})`,
            '--color': fw.color
          }}
        />
      ))}
    </div>
  );
};

export default Fireworks;
